'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./pluralize-js.cjs.production.min.js');
} else {
  module.exports = require('./pluralize-js.cjs.development.js');
}